import type { HttpClient } from "../http";
import type { CreateSampleRequest, SampleRequestDTO, UpdateSampleRequestStatus } from "../types";

export function sampleRequestsResource(http: HttpClient) {
  return {
    create: (body: CreateSampleRequest) =>
      http.post<SampleRequestDTO>("/sample-requests", body),
    list: () =>
      http.get<SampleRequestDTO[]>("/sample-requests"),
    get: (id: number) =>
      http.get<SampleRequestDTO>(`/sample-requests/${id}`),
    updateStatus: (id: number, body: UpdateSampleRequestStatus) =>
      http.patch<SampleRequestDTO>(`/sample-requests/${id}/status`, body),
  };
}
